import * as React from 'react';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Results from './pages/Results';
import Config from './pages/Config';
import WebhookSimulator from './pages/WebhookSimulator';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import EarningsDisclaimer from './pages/EarningsDisclaimer';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import { OptInScreen } from './components/OptInScreen/OptInScreen';
import WelcomeBackScreen from './components/WelcomeBackScreen';
import { SharedResultBanner } from './components/SharedResultBanner/SharedResultBanner';

const AppContent = () => {
  const [hasOptedIn, setHasOptedIn] = useState<boolean>(false);
  const [showWelcomeBack, setShowWelcomeBack] = useState(false);
  const location = window.location.pathname;
  
  // Check if user is accessing a shared result directly (e.g., /results/ABC123)
  // This allows users to view shared roasts without requiring opt-in
  const isSharedResult = /^\/results\/[^/]+/.test(location);

  useEffect(() => {
    try {
      const storedOptIn = localStorage.getItem('userOptIn');
      if (storedOptIn) {
        const { optedIn, timestamp } = JSON.parse(storedOptIn);
        setHasOptedIn(optedIn);
        
        // Only show welcome back for users returning after previous session
        // (more than 5 minutes ago)
        const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
        if (timestamp < fiveMinutesAgo) {
          setShowWelcomeBack(true);
          setTimeout(() => {
            setShowWelcomeBack(false);
          }, 3000);
        }
      }
    } catch (error) {
      console.error('Error checking opt-in status:', error);
    }
  }, []);

  // Skip opt-in screen if user is accessing a shared result
  if (!hasOptedIn && !isSharedResult) {
    return <OptInScreen onOptIn={() => setHasOptedIn(true)} />;
  }

  if (showWelcomeBack) {
    return <WelcomeBackScreen />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: '1 0 auto' }}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/results/:shareId" element={<Results />} />
          <Route path="/config" element={<Config />} />
          <Route path="/webhook-simulator" element={<WebhookSimulator />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/earnings-disclaimer" element={<EarningsDisclaimer />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      {/* Show banner only for non-opted-in users viewing shared results */}
      {isSharedResult && !hasOptedIn && <SharedResultBanner />}
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
